import { Link } from '@tanstack/react-router'
import type * as React from 'react'
import { casePartyTarget, type PartyTarget } from './links'

/** In-app link to an account or contact. Stops the click from also selecting a queue row. */
export function PartyLink({ target, children, className }: { target: PartyTarget; children: React.ReactNode; className?: string }) {
  const classNames = className ?? 'hover:underline'
  if (target.kind === 'account') {
    return (
      <Link to="/accounts/$id" params={{ id: target.id }} className={classNames} onClick={(event) => event.stopPropagation()}>
        {children}
      </Link>
    )
  }
  return (
    <Link to="/contacts/$id" params={{ id: target.id }} className={classNames} onClick={(event) => event.stopPropagation()}>
      {children}
    </Link>
  )
}

/** Queue and All-cases customer cell. Absent when the row has no account or contact id. */
export function renderCaseParty(row: Parameters<typeof casePartyTarget>[0]): ((name: string) => React.ReactNode) | undefined {
  const target = casePartyTarget(row)
  if (!target) return undefined
  return (name) => (
    <PartyLink target={target} className="hover:underline">
      {name}
    </PartyLink>
  )
}
